import React from "react";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import { backdropClasses, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from '@mui/material/styles';

export const StyledButtonPeach = styled(Button)(({ theme }) => ({
	"&:hover": {
		// background: 'linear-gradient(to right, rgb(247,64,0) 5%, rgb(255, 123, 0) 90%)',
		color: "rgb(255, 255, 255)",
		backgroundColor: "rgb(255, 107, 67)",
	},
	"&": {
		// background: 'linear-gradient(to right, rgb(247,64,0) 5%,  rgb(255, 123, 0) 90%)',
		color: "rgb(255, 255, 255)",
		fontWeight: "bold",
		letterSpacing: "0.2rem",
		backgroundColor: "rgb(255, 107, 67)",
	}
}));

export const StyledButtonPeachGradient = styled(Button)(({ theme }) => ({
	"&:hover": {
		background: 'linear-gradient(20deg, rgb(243,190,110), rgb(255,107,189))',
		color: "rgb(255, 255, 255)",
	},
	"&": {
		background: 'linear-gradient(20deg, rgb(243,190,110), rgb(255,107,189))',
		color: "rgb(255, 255, 255)",
		fontWeight: "bold",
		letterSpacing: "0.2rem",
	}
}));

export const StyledButtonBlueGradient = styled(Button)(({ theme }) => ({
	"&:hover": {
		background: 'linear-gradient(144deg,#AF40FF, #5B42F3 50%,#00DDEB)',
		color: "rgb(231, 231, 231)",
	},
	"&": {
		background: 'linear-gradient(144deg,#AF40FF, #5B42F3 50%,#00DDEB)',
		color: "rgb(231, 231, 231)",
		fontWeight: "bold",
		letterSpacing: "0.2rem"
	}
}));

export const StyledButtonRedViolet = styled(Button)(({ theme }) => ({
	"&:hover": {
		background: 'linear-gradient(60deg, rgb(190,57,48), rgb(141,68,173))',
		color: "rgb(231, 231, 231)",
	},
	"&": {
		background: 'linear-gradient(60deg, rgb(190,57,48), rgb(141,68,173))',
		color: "rgb(231, 231, 231)",
		fontWeight: "bold",
		letterSpacing: "0.2rem"
	}
}));

export const StyledButtonTeal = styled(Button)(({ theme }) => ({
	"&:hover": {
		background: 'rgb(61,162,131)',
		color: "rgb(255, 255, 255)",
	},
	"&": {
		background: 'rgb(61,162,131)',
		color: "rgb(255, 255, 255)",
		// fontWeight: "bold",
		letterSpacing: "0.055rem",
		fontSize: "0.8rem",
		padding: "0.2rem 0.9rem",
		textTransform: "none",
	}
}));